import { Link } from '@tanstack/react-router';

interface TabDef {
  slug: 'profile' | 'vacancies' | 'notes' | 'interview' | 'files' | 'audit' | 'gdpr';
  label: string;
}

const TABS: TabDef[] = [
  { slug: 'profile', label: 'Profile' },
  { slug: 'vacancies', label: 'Vacancies' },
  { slug: 'notes', label: 'Notes' },
  { slug: 'interview', label: 'Interview' },
  { slug: 'files', label: 'Files' },
  { slug: 'audit', label: 'Audit Log' },
  { slug: 'gdpr', label: 'GDPR' },
];

const TAB_TO: Record<TabDef['slug'], string> = {
  profile: '/recruitment/candidates/$id/profile',
  vacancies: '/recruitment/candidates/$id/vacancies',
  notes: '/recruitment/candidates/$id/notes',
  interview: '/recruitment/candidates/$id/interview',
  files: '/recruitment/candidates/$id/files',
  audit: '/recruitment/candidates/$id/audit',
  gdpr: '/recruitment/candidates/$id/gdpr',
};

interface CandidateProfileTabsProps {
  candidateId: string;
}

export function CandidateProfileTabs({ candidateId }: CandidateProfileTabsProps) {
  return (
    <div className="sticky top-[6.5rem] z-20 border-b border-border bg-background/95 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <nav className="flex gap-6 overflow-x-auto" aria-label="Candidate sections">
        {TABS.map((t) => (
          <Link
            key={t.slug}
            to={TAB_TO[t.slug]}
            params={{ id: candidateId }}
            activeProps={{
              className:
                "text-foreground after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:rounded-t-full after:bg-hygge after:content-['']",
            }}
            inactiveProps={{
              className: 'text-muted-foreground hover:text-foreground',
            }}
            className="relative cursor-pointer whitespace-nowrap pb-3 pt-3 text-sm font-medium transition-colors"
          >
            {t.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}